/**
 * Handle easy extraction option selection
 */
export const filterStatusMap: string[] = [
  'isWaiting',
  'isPrinted',
  'isDispatched',
  'isDiscarded',
  'isFailed',
];

export const filterErlStatusMap: string[] = [
  'isErlCreated',
  'isErlPlanned',
  'isErlReplayed',
  'isErlLreSent',
  'isErlInjected',
  'isErlSent',
  'isErlPending',
  'isErlErlFailed',
  'isErlAccepted',
  'isErlRefused',
  'isErlExpired',
  'isErlClosed',
  'isErlLreCanceled',
  'isErlSendPaper'
];

export const filterMailStatusMap: string[] = [
  'isMailingWaitingSending',
  'isMailingLinkDownload',
  'isMailingLinkClick',
  'isMailingPaper',
  'isMailingReminderSend',
  'isMailingMailFailed',
  'isMailingSendSuccess',
  'isMailingInProgress'
];
